module.exports = __webpack_public_path__ + "static/media/c.6b781914.jpg";